import type { User } from "@datadog/browser-core";
import { setDatadogLogsUser, setDatadogUser } from "@hopper-b2b/datadog";

/**
 * Nubank-only: attach Hopper UserId to both RUM and browser Logs.
 *
 * Shared `setDatadogUser` stays RUM-only so other tenants do not start
 * writing user ids into Logs without an explicit privacy decision.
 * Needed for NVH-661/1070 `@usr.id` filtering on service:nubank diagnostics.
 */
export const setNubankDatadogUser = (user: User) => {
  setDatadogUser(user);
  setDatadogLogsUser(user);
};
